import { render, staticRenderFns } from "./CambioAsientoSgaModal.vue?vue&type=template&id=5020ff2a"
import script from "./CambioAsientoSgaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioAsientoSgaModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CambioAsientoSgaModal.vue?vue&type=style&index=0&id=5020ff2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports